<template>
  <p v-if="isPrint" class="print-input">{{ dateRang.sDate }} ~ {{ dateRang.eDate }}</p>
  <div v-else class="time">
    <date-selector v-model="dateRang.sDate" :readonly="readonly" :max-date="dateRang.eDate" class="text-left" :class="readonly && 'date-readonly'" placeholder="시작일"/>
    <p>~</p>
    <date-selector v-model="dateRang.eDate" :readonly="readonly" :min-date="dateRang.sDate" class="text-left" :class="readonly && 'date-readonly'" placeholder="종료일"/>
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";

export default {
  components: {
    DateSelector,
  },
  props: {
    isPrint: Boolean,
    readonly: Boolean,
    value: { type: Object | String, default: () => ({ sDate: "", eDate: "" }) },
  },
  data() {
    return {
      dateRang: this.value,
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        if (typeof value === "string") this.dateRang = { sDate: value, eDate: value };
        else this.dateRang = value;
      },
    },
    dateRang: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
        this.$emit("sDate", value.sDate);
        this.$emit("eDate", value.eDate);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.date-readonly::v-deep {
  .vsinput input {
    background: #fafafa;
  }
}
</style>
